// src/App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; 

import NavigationSection from './components/Navigation'; 
import HomePage from './components/HomePage';
import About from './components/About'; 
import CustomSoftwareDevelopment from './components/CustomSoftwareDevelopment'; 
import UIDesign from './components/UIDesign';
import MobileDevelopment from './components/MobileDevelopment';
import MVPBuilder from './components/MVPBuilder';
import Footer from './components/Footer';
import LandscapeWarning from './components/LandscapeWarning';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Router>
      <div className="relative">
        <NavigationSection setIsMenuOpen={setIsMenuOpen} />
        
        {/* Overlay */}
        {isMenuOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 pointer-events-none"
          />
        )}

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/service-custom-software-development" element={<CustomSoftwareDevelopment />} />
          <Route path="/service-ui-design" element={<UIDesign />} />
          <Route path="/service-mobile-development" element={<MobileDevelopment />} />
          <Route path="/service-mvp-builder" element={<MVPBuilder />} />
        </Routes>

        <Footer />

        {/* Landscape warning */}
        <LandscapeWarning />
      </div>
    </Router>
  );
}

export default App;
